/**
 * Single API client for all Worker endpoints.
 *
 * Uses cookie-based authentication (HttpOnly `token` cookie set by the Worker).
 * In production the API is same-origin (Pages Functions proxy /api and /auth to
 * the Worker), so the cookie is first-party; `withCredentials` only matters for
 * local dev, where the UI and the Worker run on different localhost ports.
 *
 * Base URL is read from `process.env.REACT_APP_API_URL` (empty = same origin).
 */

import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL !== undefined ? process.env.REACT_APP_API_URL : '';

const apiClient = axios.create({
  baseURL: API_BASE,
  headers: { 'Content-Type': 'application/json' },
  withCredentials: true, // Send HttpOnly cookies with every request
});

// Handle 403 tenant rejection → clear auth & redirect to /
// Only intercepts specific tenant-related errors; other 403s propagate.
apiClient.interceptors.response.use(
  (res) => res,
  async (error) => {
    if (error.response?.status === 403) {
      const errorMsg = error.response?.data?.error || '';
      if (errorMsg === 'Unauthorized tenant access' || errorMsg === 'User must be assigned to an organization first') {
        window.location.href = '/';
        return; // Handled — don't reject
      }
    }
    if (error.response && error.response.status === 401) {
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export { apiClient, API_BASE };
